<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid v-if="reservation.show || 1">
                              <v-layout row wrap>
                                  <v-col cols="12">
                                      <h2>Edit Stay Dates</h2>
                                  </v-col>

                                  <v-col cols="12">Please choose the new stay dates and provide a reason for the change</v-col>

                                  <v-col cols="12" md="2">
                                      <label>Arrival Date:</label>
                                  </v-col>
                                  <v-col cols="12" md="10">
                                      <v-date-picker v-model="arrivalDate" 
                                                     landscape ></v-date-picker>
                                  </v-col>

                                  <v-col cols="12" md="2">
                                      <label>Departure Date:</label>
                                  </v-col>
                                  <v-col cols="12" md="10">
                                      <v-date-picker v-model="departureDate" 
                                                     landscape ></v-date-picker>
                                  </v-col>

                                  <v-col cols="12" md="2">
                                      <label>Reason:</label>
                                  </v-col>
                                  <v-col cols="12" md="10">
                                      <v-text-field
                                         name="reason" 
                                         v-model="reason"
                                      ></v-text-field>
                                  </v-col>
                              </v-layout>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-btn class="" 
                              v-on:click="cancel"
                              title="Cancel without changes">Cancel</v-btn>
                          <v-btn class="ies-green" 
                              title="Save the changes to the reservation"
                              v-on:click="saveChanges">Save</v-btn>
                      </v-card-actions>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user edit a reservation's
     * stay dates by the ID specified
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */
    import axios from 'axios';
    // Import the application event bus so we can listen for data changes and react accordingly
    import EventBus from '@/eventBus';
    export default {
        name: 'hotel-reservation-change-dates',
        props: ['reservationkey'],
        data () {
            return {
                arrivalDate: '',
                departureDate: '',
                reason: "",
                reservation: {},
            }
        },
        methods: {

            /**
             * Register event listener that will be listening for clearSelector event to clear it's selected state
             */
            setUpEventListener() {
                EventBus.$on('Reservation Administration: Reservation changed', this.onReservationChanged);
            },

            /**
             * @method onReservationChanged
             * 
             * Respond to the reservation having been edited
             * by checking if the event is talking about this reservation,
             * and if so then reload it afresh so we are displaying all of
             * the correct data across the board
             * 
             * @param payload 
             */
            onReservationChanged(payload){
                if (payload.reservationKey == this.reservationkey){
                   this.loadReservation();
                }
            },

            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey + '?a=b')
                .then(function(response){
                    this.reservation = response.data.reservation;
                    this.arrivalDate = this.reservation.date_arrival ? this.localDateString(new Date(this.reservation.date_arrival)) : '';
                    this.departureDate = this.reservation.date_departure ? this.localDateString(new Date(this.reservation.date_departure)) : '';
                }.bind(this));
            },

            localDateString(date){
                return date.getFullYear() + '-' +
                    String(date.getMonth() + 1).padStart(2, '0') + '-' +
                    String(date.getDate()).padStart(2, '0');
            },

            /**
             * Push the changes up to the server
             */
            saveChanges(){
                var params = {
                                 "dateArrival": this.arrivalDate,
                                 "dateDeparture": this.departureDate,
                                 "reason": this.reason
                };
                axios.post('/api/reservation/' + this.reservationkey + '/set-dates', params)
                .then(function(response){
                    alert("Stay dates changed");
                    EventBus.$emit('Reservation Administration: Reservation changed', {'reservationKey': this.reservationkey});
                    EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'manage reservation'});
                }.bind(this));
            },

            cancel(){
                EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'manage reservation'});
            },

            /**
             * Returns the day of the week by abbreviated name
             * e.g. 1 = "Mon", 2 = "Tue" etc
             */
            getDayAbbreviated(dayIndex){
                var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                return days[dayIndex];
            },

            /**
             * Returns the month of the year by abbreviated name
             * e.g. 1 = "Feb", 2 = "Mar" etc
             */
            getMonthAbbreviated(monthIndex){
                var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                return months[monthIndex];
            }
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
        },

        computed: {}
    }
</script>

